/**
 * Converts a file to a data URL.
 * @param {File} file - The file to convert.
 * @returns {Promise<ArrayBuffer | null | string>} A Promise that resolves to the data URL.
 */
export function fileToDataURL(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => {
      reader.abort();
      reject(new Error('Failed to read file as base64'));
    };
    reader.onload = () => resolve(reader.result);
    reader.readAsDataURL(file);
  });
}
